<template>
  <div
    class="researched-company d-flex flex-column px-3 py-1 border-bottom
    align-items-left justify-content-center"
    style="min-height: 70px"
  >
    <p class="mb-0">
      {{ company.name }}
      <span v-if="company.name !== '' && company.siret">-</span>
      {{ company.siret }}
    </p>
    <p
      class="text-gray-400 mb-0 animated small"
      style="text-transform:capitalize"
    >
      {{ addressFormatter(company) || 'Poursuivre avec ce siret' }}
    </p>
  </div>
</template>
<script>
import _Strings from '@/utils/_Strings';

export default {
  props: {
    company: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    addressFormatter: (company) => _Strings.addressFormatter(company),
  },
};
</script>
<style scoped>
.researched-company:hover{
  cursor: pointer;
  background-color: #EDF4FD;
}
</style>
